export default "__VITE_ASSET__3d96ab4d__"